import { c as _c } from "react-compiler-runtime";
import classNames from "clsx";
import * as React from "react";
import { Button as AriaButton, Link as AriaLink } from "react-aria-components";
import { icon } from "../icon.css.js";
import { button, buttonContent, buttonText, destructiveButton, disabledButton, loadingButtonContent } from "./Button.css.js";
import { Spinner as DesignSystemSpinner } from "./Spinner.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function populateDefaults(props) {
  const {
    hierarchy = "primary",
    size = "m",
    destructive = false,
    loading = false,
    ...rest
  } = props;
  return {
    hierarchy,
    size,
    destructive,
    loading,
    ...rest
  };
}
export const Button = t0 => {
  const $ = _c(32);
  let buttonRef;
  let children;
  let destructive;
  let disabled;
  let hierarchy;
  let loading;
  let onPress;
  let props;
  let restProps;
  let size;
  let t1;
  let type;
  let wrapperClassname;
  if ($[0] !== t0) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        children: t2,
        ...unsafeProps
      } = t0;
      children = t2;
      props = populateDefaults(unsafeProps);
      const {
        hierarchy: t3,
        size: t4,
        destructive: t5,
        loading: t6,
        disabled: t7,
        variant,
        outline: t8
      } = props;
      hierarchy = t3;
      size = t4;
      destructive = t5;
      loading = t6;
      disabled = t7;
      const outline = t8 === undefined ? false : t8;
      if (props.variant === "link") {
        const {
          anchorRef,
          ...rest
        } = props;
        t1 = /*#__PURE__*/_jsx(Link, {
          ref: anchorRef,
          ...rest,
          children: children
        });
        break bb0;
      }
      wrapperClassname = classNames(button({
        size,
        hierarchy,
        iconOnly: variant === "iconOnly",
        loading,
        outline
      }), disabled === true ? disabledButton({
        hierarchy
      }) : destructive === true && destructiveButton({
        hierarchy
      }));
      ({
        type,
        onPress,
        buttonRef,
        ...restProps
      } = props);
      if (variant === "iconOnly" && loading === true) {
        t1 = /*#__PURE__*/_jsx(AriaButton, {
          className: wrapperClassname,
          type: type,
          onPress: onPress,
          ref: buttonRef,
          isDisabled: disabled,
          isPending: true,
          ...restProps,
          children: /*#__PURE__*/_jsx(Spinner, {
            size: size,
            hierarchy: hierarchy,
            destructive: destructive
          })
        });
        break bb0;
      }
      if (variant === "iconOnly") {
        const Icon = props.leadingIcon;
        t1 = /*#__PURE__*/_jsx(AriaButton, {
          className: wrapperClassname,
          type: type,
          onPress: onPress,
          isDisabled: disabled,
          ref: buttonRef,
          ...restProps,
          children: /*#__PURE__*/_jsx(Icon, {
            className: icon({
              size
            })
          })
        });
        break bb0;
      }
    }
    $[0] = t0;
    $[1] = buttonRef;
    $[2] = children;
    $[3] = destructive;
    $[4] = disabled;
    $[5] = hierarchy;
    $[6] = loading;
    $[7] = onPress;
    $[8] = props;
    $[9] = restProps;
    $[10] = size;
    $[11] = t1;
    $[12] = type;
    $[13] = wrapperClassname;
  } else {
    buttonRef = $[1];
    children = $[2];
    destructive = $[3];
    disabled = $[4];
    hierarchy = $[5];
    loading = $[6];
    onPress = $[7];
    props = $[8];
    restProps = $[9];
    size = $[10];
    t1 = $[11];
    type = $[12];
    wrapperClassname = $[13];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  let t2;
  if ($[14] !== children || $[15] !== props) {
    t2 = /*#__PURE__*/_jsx(ButtonContent, {
      ...props,
      children: children
    });
    $[14] = children;
    $[15] = props;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== destructive || $[18] !== hierarchy || $[19] !== loading || $[20] !== size) {
    t3 = loading === true && /*#__PURE__*/_jsx(Spinner, {
      size: size,
      hierarchy: hierarchy,
      destructive: destructive
    });
    $[17] = destructive;
    $[18] = hierarchy;
    $[19] = loading;
    $[20] = size;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== buttonRef || $[23] !== disabled || $[24] !== loading || $[25] !== onPress || $[26] !== restProps || $[27] !== t2 || $[28] !== t3 || $[29] !== type || $[30] !== wrapperClassname) {
    t4 = /*#__PURE__*/_jsxs(AriaButton, {
      className: wrapperClassname,
      type: type,
      onPress: onPress,
      ref: buttonRef,
      isDisabled: disabled,
      isPending: loading,
      ...restProps,
      children: [t2, t3]
    });
    $[22] = buttonRef;
    $[23] = disabled;
    $[24] = loading;
    $[25] = onPress;
    $[26] = restProps;
    $[27] = t2;
    $[28] = t3;
    $[29] = type;
    $[30] = wrapperClassname;
    $[31] = t4;
  } else {
    t4 = $[31];
  }
  return t4;
};
const BaseLink = (t0, ref) => {
  const $ = _c(14);
  let children;
  let disabled;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    const {
      hierarchy,
      size,
      disabled: t2
    } = props;
    disabled = t2;
    t1 = classNames(button({
      size,
      hierarchy
    }), disabled === true && disabledButton({
      hierarchy
    }));
    $[0] = t0;
    $[1] = children;
    $[2] = disabled;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    disabled = $[2];
    props = $[3];
    t1 = $[4];
  }
  const wrapperClassname = t1;
  let t2;
  if ($[5] !== children || $[6] !== props) {
    t2 = /*#__PURE__*/_jsx(ButtonContent, {
      ...props,
      children: children
    });
    $[5] = children;
    $[6] = props;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== disabled || $[9] !== props || $[10] !== ref || $[11] !== t2 || $[12] !== wrapperClassname) {
    t3 = /*#__PURE__*/_jsx(AriaLink, {
      className: wrapperClassname,
      ref: ref,
      isDisabled: disabled,
      ...props,
      children: t2
    });
    $[8] = disabled;
    $[9] = props;
    $[10] = ref;
    $[11] = t2;
    $[12] = wrapperClassname;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
const Link = /*#__PURE__*/React.forwardRef(BaseLink);
function ButtonContent(props) {
  const $ = _c(19);
  const {
    leadingIcon: LeadingIcon,
    trailingIcon: TrailingIcon
  } = props;
  const {
    size,
    hierarchy,
    destructive,
    loading,
    children
  } = props;
  let t0;
  if ($[0] !== destructive || $[1] !== hierarchy || $[2] !== loading || $[3] !== size) {
    t0 = classNames(buttonContent({
      size
    }), loading === true && loadingButtonContent({
      hierarchy,
      destructive
    }));
    $[0] = destructive;
    $[1] = hierarchy;
    $[2] = loading;
    $[3] = size;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== LeadingIcon || $[6] !== size) {
    t1 = LeadingIcon && /*#__PURE__*/_jsx(LeadingIcon, {
      className: icon({
        size
      })
    });
    $[5] = LeadingIcon;
    $[6] = size;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== size) {
    t2 = children != null && /*#__PURE__*/_jsx("span", {
      className: buttonText({
        size
      }),
      children: children
    });
    $[8] = children;
    $[9] = size;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== TrailingIcon || $[12] !== size) {
    t3 = TrailingIcon && /*#__PURE__*/_jsx(TrailingIcon, {
      className: icon({
        size
      })
    });
    $[11] = TrailingIcon;
    $[12] = size;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t0 || $[15] !== t1 || $[16] !== t2 || $[17] !== t3) {
    t4 = /*#__PURE__*/_jsxs("div", {
      className: t0,
      children: [t1, t2, t3]
    });
    $[14] = t0;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}
function getSpinnerColor(hierarchy, destructive) {
  if (!hierarchy) {
    return destructive === true ? "destructive" : "white";
  }
  if (destructive === true) {
    switch (hierarchy) {
      case "primary":
        {
          return "white";
        }
      default:
        {
          return "destructive";
        }
    }
  }
  switch (hierarchy) {
    case "primary":
      {
        return "white";
      }
    case "alertError":
      {
        return "destructive";
      }
    case "alertSuccess":
    case "alertWarning":
      {
        return hierarchy;
      }
    case "alertWarningSecondary":
      {
        return "alertWarning";
      }
    default:
      {
        return "royalBlue";
      }
  }
}
const Spinner = t0 => {
  const $ = _c(6);
  const {
    size,
    hierarchy,
    destructive
  } = t0;
  let t1;
  if ($[0] !== destructive || $[1] !== hierarchy) {
    t1 = getSpinnerColor(hierarchy, destructive);
    $[0] = destructive;
    $[1] = hierarchy;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== size || $[4] !== t1) {
    t2 = /*#__PURE__*/_jsx(DesignSystemSpinner, {
      size: size,
      color: t1
    });
    $[3] = size;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
//# sourceMappingURL=Button.js.map